// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1CyYq","itemTitle":"ClientEmergencyInfo_itemTitle__1xx9H","itemText":"ClientEmergencyInfo_itemText__22dbs"};